const slidesContainer = document.querySelector('#slides');
const slides = slidesContainer.children;
const nextSlide = document.querySelector('#rightSlide');
const prevSlide = document.querySelector('#leftSlide');
const totalSlides = slides.length;
let index = 0;

nextSlide.addEventListener('click', () => {
  next('next');
});

prevSlide.addEventListener('click', () => {
  next('prev');
});

const next = (direction) => {
  if (direction == 'next') {
    index ++;
    if (index == totalSlides) {
      index = 0;
    }
  }

  else {
    if (index == 0) {
      index = totalSlides - 1;
    }
    else {
      index --;
    }
  }
  for (let i = 0; i < slides.length; i++) {
    slides[i].classList.remove('tesla-slider__image--visible');
  }
  slides[index].classList.add('tesla-slider__image--visible');
};
